export const CELL_PADDING = 5;
export const DEFAULT_COL_MIN_WIDTH = 150;
export const DEFAULT_COL_WIDTH = 1;
export const MORE_ACTIONS_TITLE = "More";
export const MORE_ACTIONS_HOVER_TITLE = "More actions";
export const BULK_SELECT_COLUMN_WIDTH = 15 + CELL_PADDING * 2;
export const BULK_SELECT_COL_ID = "bulk-select";
export const ACTIONS_COL_ID = "actions";
export const UTILITY_COLUMNS = /* @__PURE__ */ new Set([BULK_SELECT_COL_ID, ACTIONS_COL_ID]);
export const ATTRIBUTE_STATUS = {
  show: "show",
  hide: "hide"
};
